import "./TermiteTreatment.module.css";
import MainNavigation from "@/reusable_sections/Header";
import PageHero from "./sections/PageHero";
import WhyNeighborsChooseWallice from "./sections/WhyNeighborsChooseWallice";
import UnmatchedExcellence from "./sections/UnmatchedExcellence";
import Termitepreventionfaq from "./sections/Termitepreventionfaq";
import SystemFooter from "@/reusable_sections/Footer";
export default function TermiteTreatmentPage() {
  return <div>
      <MainNavigation />
      <PageHero />
      <WhyNeighborsChooseWallice />
      <UnmatchedExcellence />
      <Termitepreventionfaq />
      <SystemFooter />
    </div>;
}